import React from "react";
import ContentHeading from "@/components/content-heading";
import {
    container,
    heading,
    subheading,
    emailDetails,
    emails,
    contactIcon,
    phoneDetails,
    contactNumber
} from "@/components/support/styles/contact-header";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {ISupportContent} from "@/components/support/interfaces/ISupportContent";
import supportData from "@/i18n/json/support/data.json"

const SupportContactDetails: React.FC<ISupportContent> = () => {

    return (
        <section className={container} title={"hearX Group contact information"} aria-label={"White background"}>
            <div className={heading}>
                <ContentHeading
                    h="p"
                    className="mobile:justify-center tablet:justify-start"
                    backdropPosition="mobile:left-4 tablet:left-8"
                    fontSize="mobile:text-2xl tablet:text-5xl"
                    background="bg-primary bg-opacity-50"
                >
                    Contact us
                </ContentHeading>
                <p className={subheading}>
                    Please contact us via email.
                </p>
            </div>

            {/*Contact details*/}
            <div >
                <div className={emailDetails}>
                    <ul>
                        <li className={emails}>
                            <LazyLoadImage className={contactIcon} src="/assets/icons/contact/email.svg"/>
                            <a href={"mailto:info@hearxgroup.com"}>
                                General enquiries: <strong>{supportData["contact-details"].enquiries.info}</strong>
                            </a>
                        </li>
                        <li className={emails}>
                            <LazyLoadImage className={contactIcon} src="/assets/icons/contact/email.svg"/>
                            <a href={"mailto:sales@hearxgroup.com"}>
                                Sales enquiries: <strong>{supportData["contact-details"].enquiries.sales}</strong>
                            </a>
                        </li>
                        <li className={emails}>
                            <LazyLoadImage className={contactIcon} src="/assets/icons/contact/email.svg"/>
                            <a href={"mailto:support@hearxgroup.com"}>
                                Support enquiries: <strong>{supportData["contact-details"].enquiries.support}</strong>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            {/*telephone*/}
            <div className={phoneDetails}>
                <div className={contactNumber}>
                    <LazyLoadImage className={contactIcon} src="/assets/icons/contact/phone.svg"/>
                    <a href="tel:(415) 212-5500"><strong>US:</strong> {supportData["telephone"].us}</a>
                </div>
                <div className={contactNumber}>
                    <LazyLoadImage className={contactIcon} src="/assets/icons/contact/phone.svg"/>
                    <a href="tel+27 (0) 64 610 8897"><strong>RSA:</strong> {supportData["telephone"].rsa}</a>
                </div>
            </div>
        </section>
    )
};

export default SupportContactDetails;
